export default [
  {
    path: 'M615.6 123.6h165.5L512 589.7 242.9 123.6H63.5L512 900.4l448.5-776.9z',
    fill: '#41B883',
  },
  {
    path: 'M781.1 123.6H615.6L512 303 408.4 123.6H242.9L512 589.7z',
    fill: '#34495E',
  },
]
